/**
 * 登录页面 Mock 数据服务
 * 提供用户协议、隐私政策、footer配置等数据
 */

// 用户协议内容
const userAgreement = {
  id: 1,
  title: '服务协议',
  version: 'V1.0',
  updateTime: Date.now(),
  content: `
<div class="agreement-content">
  <h1>服务协议</h1>
  <p class="update-time">更新日期：2025年12月16日</p>
  
  <h2>一、协议的范围</h2>
  <p>1.1 本协议是您与智慧云行(成都)科技有限公司（以下简称"本公司"）之间关于您使用本公司提供的定制客运管理系统（以下简称"本系统"）相关服务所订立的协议。</p>
  <p>1.2 本协议内容包括协议正文及所有本公司已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。</p>
  
  <h2>二、账号注册与使用</h2>
  <p>2.1 用户在使用本系统服务前需要注册一个账号。账号应当使用手机号码绑定注册，请用户使用尚未与本系统账号绑定的手机号码，以及未被本系统根据本协议封禁的手机号码注册账号。</p>
  <p>2.2 用户注册成功后，本系统将给予每个用户一个用户账号及相应的密码，该用户账号和密码由用户负责保管；用户应当对以其用户账号进行的所有活动和事件负法律责任。</p>
  <p>2.3 用户不得以任何形式转让或授权他人使用自己的账号，亦不得盗用他人账号。</p>
  
  <h2>三、用户个人信息保护</h2>
  <p>3.1 保护用户个人信息是本公司的一项基本原则。本公司将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。</p>
  <p>3.2 您在注册账号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
  
  <h2>四、服务内容</h2>
  <p>4.1 本系统提供的服务包括但不限于：定制客运订单管理、车辆调度、司机管理、乘客管理、财务管理、数据统计分析等功能。</p>
  <p>4.2 本公司有权根据实际情况随时调整本系统提供的服务种类、形式。</p>
  
  <h2>五、用户行为规范</h2>
  <p>5.1 用户在使用本系统服务时，必须遵守中华人民共和国相关法律法规，不得利用本系统从事以下行为：</p>
  <p>（1）发布、传送、传播、储存违反国家法律法规的内容；</p>
  <p>（2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
  <p>（3）虚构事实、隐瞒真相以误导、欺骗他人；</p>
  <p>（4）发布、传送、传播广告信息及垃圾信息；</p>
  <p>（5）从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</p>
  
  <h2>六、知识产权</h2>
  <p>6.1 本系统所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计等，均由本公司或其他权利人依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。</p>
  <p>6.2 非经本公司或其他权利人书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本系统程序或内容。</p>
  
  <h2>七、免责声明</h2>
  <p>7.1 本公司不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。</p>
  <p>7.2 对于因不可抗力或本公司不能控制的原因造成的网络服务中断或其它缺陷，本公司不承担任何责任。</p>
  
  <h2>八、协议的修改</h2>
  <p>8.1 本公司有权随时修改本协议的任何条款，一旦本协议的内容发生变动，本公司将会在相关页面上提示修改内容。</p>
  <p>8.2 如果不同意本公司对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本公司对本协议相关条款所做的修改。</p>
  
  <h2>九、法律适用与争议解决</h2>
  <p>9.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
  <p>9.2 如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向本公司所在地的人民法院提起诉讼。</p>
  
  <h2>十、其他</h2>
  <p>10.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
  <p>10.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
  
  <p class="contact-info">如有任何疑问，请联系我们：</p>
  <p class="contact-info">客服电话：4000490016</p>
  <p class="contact-info">客服邮箱：service@zhihuiyunxing.com</p>
  <p class="contact-info">公司网站：https://www.zhihuiyunxing.com</p>
  <p class="contact-info">公司地址：四川省成都市武侯区智星三路331号1层</p>
</div>
  `
}

// 隐私政策内容
const privacyPolicy = {
  id: 2,
  title: '隐私政策',
  version: 'V1.0',
  updateTime: Date.now(),
  content: `
<div class="agreement-content">
  <h1>隐私政策</h1>
  <p class="update-time">更新日期：2025年12月16日</p>
  
  <h2>引言</h2>
  <p>智慧云行(成都)科技有限公司（以下简称"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
  
  <h2>一、我们如何收集和使用您的个人信息</h2>
  <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
  
  <h3>1.1 我们收集的信息</h3>
  <p>在您使用我们的服务时，我们可能会收集以下信息：</p>
  <p>（1）账户信息：当您注册账户时，我们会收集您的手机号码、密码等信息；</p>
  <p>（2）身份信息：为了满足相关法律法规要求，您可能需要提供真实姓名、身份证号码等信息；</p>
  <p>（3）设备信息：我们会收集您使用的设备信息，包括设备型号、操作系统版本、设备标识符等；</p>
  <p>（4）日志信息：当您使用我们的服务时，我们会自动收集您的详细使用情况，作为有关网络日志保存；</p>
  <p>（5）位置信息：为了提供更好的服务，我们可能会收集您的位置信息。</p>
  
  <h3>1.2 我们如何使用收集的信息</h3>
  <p>我们收集和使用您的个人信息，是为了向您提供服务及提升服务质量的目的，具体包括：</p>
  <p>（1）向您提供您使用的各项服务，并维护、改进这些服务；</p>
  <p>（2）为预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为；</p>
  <p>（3）经您许可的其他用途。</p>
  
  <h2>二、我们如何使用Cookie和同类技术</h2>
  <p>2.1 为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。</p>
  <p>2.2 我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。</p>
  
  <h2>三、我们如何共享、转让、公开披露您的个人信息</h2>
  <h3>3.1 共享</h3>
  <p>我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
  <p>（1）在获取明确同意的情况下共享；</p>
  <p>（2）根据法律法规的规定或行政或司法机构的要求；</p>
  <p>（3）在法律法规允许的范围内，为维护本公司、本公司的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害。</p>
  
  <h3>3.2 转让</h3>
  <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
  <p>（1）在获取明确同意的情况下转让；</p>
  <p>（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束。</p>
  
  <h3>3.3 公开披露</h3>
  <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
  <p>（1）获得您明确同意后；</p>
  <p>（2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
  
  <h2>四、我们如何保护您的个人信息</h2>
  <p>4.1 我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>
  <p>4.2 我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与"服务"之间交换数据时受SSL加密保护。</p>
  <p>4.3 我们会采取一切合理可行的措施，确保未收集无关的个人信息。</p>
  
  <h2>五、您的权利</h2>
  <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
  <p>5.1 访问您的个人信息</p>
  <p>5.2 更正您的个人信息</p>
  <p>5.3 删除您的个人信息</p>
  <p>5.4 改变您授权同意的范围</p>
  <p>5.5 注销账户</p>
  
  <h2>六、未成年人的个人信息保护</h2>
  <p>6.1 我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您家长或法定监护人的书面同意。</p>
  <p>6.2 对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
  
  <h2>七、本政策如何更新</h2>
  <p>7.1 我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。</p>
  <p>7.2 对于重大变更，我们会提供显著的通知（包括对于某些服务，我们会通过站内信的方式进行通知，说明隐私政策的具体变更内容）。</p>
  
  <h2>八、如何联系我们</h2>
  <p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
  <p class="contact-info">客服电话：4000490016</p>
  <p class="contact-info">客服邮箱：service@zhihuiyunxing.com</p>
  <p class="contact-info">公司网站：https://www.zhihuiyunxing.com</p>
  <p class="contact-info">公司地址：四川省成都市武侯区智星三路331号1层</p>
  <p class="contact-info">我们将在15个工作日内回复您的请求。</p>
</div>
  `
}

// Footer配置信息
const footerConfig = {
  id: 1,
  copyright: {
    year: `2020 - ${new Date().getFullYear()}`,
    company: '智慧云行(成都)科技有限公司',
    companyName: '顺风侠城际出行',
    companyUrl: 'https://www.zhihuiyunxing.com',
    allRightsReserved: 'SHUNFENGXIA. All Rights Reserved.'
  },
  icp: {
    number: '蜀ICP备2020030731号-3',
    url: 'https://beian.miit.gov.cn/#/Integrated/index'
  },
  links: [
    {
      id: 1,
      name: '服务协议',
      type: 'agreement',
      url: ''
    },
    {
      id: 2,
      name: '隐私政策',
      type: 'privacy',
      url: ''
    }
  ],
  contact: {
    phone: '4000490016',
    email: 'service@zhihuiyunxing.com',
    address: '四川省成都市武侯区智星三路331号1层',
    website: 'https://www.zhihuiyunxing.com',
    foundedDate: '2020年7月23日'
  }
}

// Mock API接口
export default {
  /**
   * 获取用户协议
   */
  getUserAgreement() {
    return {
      code: 1,
      msg: '获取成功',
      data: userAgreement
    }
  },

  /**
   * 获取隐私政策
   */
  getPrivacyPolicy() {
    return {
      code: 1,
      msg: '获取成功',
      data: privacyPolicy
    }
  },

  /**
   * 获取Footer配置
   */
  getFooterConfig() {
    return {
      code: 1,
      msg: '获取成功',
      data: footerConfig
    }
  },

  /**
   * 根据类型获取协议内容
   * @param {string} type - agreement: 用户协议, privacy: 隐私政策
   */
  getAgreementByType(type) {
    if (type === 'agreement') {
      return this.getUserAgreement()
    } else if (type === 'privacy') {
      return this.getPrivacyPolicy()
    }
    return {
      code: 0,
      msg: '类型错误',
      data: null
    }
  }
}
